import { Article } from "@/hooks/useArticles";
import BlogsSection from "@/components/ui/blogs";

interface RelatedArticlesProps {
  articles: Article[];
  categoryName: string;
  categorySlug: string;
}

export function RelatedArticles({ articles, categoryName, categorySlug }: RelatedArticlesProps) {
  return (
    <BlogsSection
      articles={articles}
      categoryName={categoryName}
      categorySlug={categorySlug}
    />
  );
}

export default RelatedArticles;
